export * from './pagination.component';
export * from './pagination.module';